const styles = {
    container: (theme, isMobile) => ({
        display: "flex",
        minHeight: "100vh",
        backgroundColor: theme.palette.background.default,
        flexDirection: isMobile ? "column" : "row",
    }),

    leftPanel: {
        flex: 2,
        backgroundColor: "#f5f5f5",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 4,
    },

    title: (theme) => ({
        fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
        fontWeight: "bold",
        textTransform: "uppercase",
        color: theme.palette.text.primary,
        marginBottom: 2,
    }),

    separator: (theme) => ({
        width: "50%",
        borderBottom: `3px solid ${theme.palette.text.primary}`,
        marginBottom: 2,
    }),

    subtitle: (theme) => ({
        fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
        textAlign: "center",
        fontSize: "1.1rem",
        color: theme.palette.text.secondary,
    }),

    description: (theme) => ({
        fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
        textAlign: "center",
        fontSize: "1rem",
        color: theme.palette.text.secondary,
        marginTop: 1,
    }),

    formContainer: {
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 2,
    },

    formBox: {
        width: "100%",
        maxWidth: 400,
        padding: 4,
    },

    formTitle: {
        fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
        textAlign: "left",
        fontWeight: "normal",
        textTransform: "uppercase",
        marginBottom: 1,
    },

    formSubtitle: {
        textAlign: "left",
        marginBottom: 3,
    },

    button: {
        width: "100%",
    },

    linkText: {
        textAlign: "center",
        marginTop: 2,
    },
};

export default styles;
